/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';

import { resetFilters, toggleSelectedTeamsFilter } from 'app/actions/playerListActions';
import TeamsFilter from '../TeamsFilter';

type Props = {
  selectedTeams: Array<string>,
  games: Array<*>,
  teamIds: Array<string>,
  onTeamsChange: () => void
};

function TeamsContent({ selectedTeams, games, teamIds, onTeamsChange }: Props) {
  return (
    <div>
      <p>
        Players from unselected teams will not be displayed on cruncher or used in crunched lineups
      </p>
      <TeamsFilter
        selectedTeams={selectedTeams || []}
        games={games}
        teamIds={teamIds}
        onTeamsChange={onTeamsChange}
      />
    </div>
  );
}

function mapStateToProps(state: GlobalState) {
  return {
    teamIds: !isEmpty(state.challenge.teams) ? Object.keys(state.challenge.teams) : [],
    selectedTeams: state.playerList.selectedTeams,
    games: state.challenge.games
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onReset: () => dispatch(resetFilters()),
    onTeamsChange: teamId => dispatch(toggleSelectedTeamsFilter(teamId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamsContent);
